/**
 * Returns the value of the given url parameter, or undefined if it does not exist.
 * @param name The name of the url parameter to check.
 * @param urlOverride If provided, this url will be used as the source url. Otherwise, [[location.href]] will be used.
 */
export const getUrlParameter = (name, urlOverride) => {
    var _a;
    const url = getUrlOrDefault(urlOverride);
    const urlParams = new URLSearchParams(url.search);
    return (_a = urlParams.get(name)) !== null && _a !== void 0 ? _a : undefined;
};
/**
 * Returns true if the given url parameter exists.
 * @param name The name of the url parameter to check.
 * @param urlOverride If provided, this url will be used as the source url. Otherwise, [[location.href]] will be used.
 */
export const hasUrlParameter = (name, urlOverride) => !!getUrlParameter(name, urlOverride);
/**
 * Returns a url with the given parameter excluded.
 * @param parameterToExclude The name of the url parameter to exclude from the returned url.
 * @param urlOverride If provided, this url will be used as the source url. Otherwise, [[location.href]] will be used.
 */
export const getUrlExcludingUrlParameter = (parameterToExclude, urlOverride) => {
    const url = getUrlOrDefault(urlOverride);
    const urlExcludingUrlParams = `${url.protocol}//${url.host}${url.pathname}`;
    const urlParams = new URLSearchParams(url.search);
    urlParams.delete(parameterToExclude);
    return urlParams.toString() ? `${urlExcludingUrlParams}?${urlParams}` : urlExcludingUrlParams;
};
/**
 * Removes the url parameter from the current url, then replaces the browser's url without reloading the page.
 * This replaces the browser's history of the url prior to the removal, so the back button will skip the original url.
 */
export const removeUrlParameterWithoutReload = (parameterToRemove) => {
    if (!hasUrlParameter(parameterToRemove))
        return;
    const newUrl = getUrlExcludingUrlParameter(parameterToRemove);
    window.history.replaceState({}, document.title, newUrl);
};
const getUrlOrDefault = (url) => {
    const urlString = url !== null && url !== void 0 ? url : location.href;
    return new URL(urlString);
};
